var map = {
	"./about-us-bg": 3,
	"./about-us-bg.png": 3,
	"./favicons/apple-touch-icon-180x180": 4,
	"./favicons/apple-touch-icon-180x180.png": 4,
	"./favicons/favicon.ico": 24,
	"./icons/burger": 5,
	"./icons/burger.svg": 5,
	"./icons/call": 6,
	"./icons/call.png": 6,
	"./icons/cross": 7,
	"./icons/cross.svg": 7,
	"./icons/en": 8,
	"./icons/en.svg": 8,
	"./icons/location": 9,
	"./icons/location.png": 9,
	"./icons/mail": 10,
	"./icons/mail.png": 10,
	"./icons/ru": 11,
	"./icons/ru.svg": 11,
	"./main-bg": 12,
	"./main-bg.jpg": 12
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23;